import { Team } from "../model/Team";
import { Country } from "../model/Country";
export const getTeamCountry = (team) => {
    switch (team) {
        case Team.Oslo:
        case Team.Fredrikstad:
        case Team.Mortgage:
            return Country.Norge;
        case Team.Polska:
            return Country.Polska;
        default:
            return Country.Norge;
    }
};
